// extracted by mini-css-extract-plugin
export var container = "VacationBanner-module--container--1EbU5";
export var withChristmas = "VacationBanner-module--withChristmas--2ZHX4";